<script lang="ts">
	import DatasheetDetailBlock from '$lib/components/pois/datasheet/detail/DatasheetDetailBlock.svelte';
	import * as m from '$paraglide/messages';
	import { watch } from 'runed';

	interface Props {
		title: string;
		text: string;
	}

	const { title, text }: Props = $props();
	let isOverflowed = $state(false);
	let isExpanded = $state(false);
	let textBox: HTMLDivElement | undefined = $state();
	let borderBoxSize: ResizeObserverSize[] | undefined = $state();

	function updateSize(): void {
		if (!textBox) {
			return;
		}

		isOverflowed = !!(
			textBox?.offsetHeight < textBox?.scrollHeight || textBox?.offsetWidth < textBox?.scrollWidth
		);
	}

	function expandText() {
		isExpanded = true;
	}
	watch(() => borderBoxSize, () => {
		updateSize();
	});
</script>

<DatasheetDetailBlock {title}>
	<div class={[!isExpanded && 'clamp-lines-7']} bind:this={textBox} bind:borderBoxSize>{text}</div>
	{#if isOverflowed && !isExpanded}
		<button
			type="button"
			onclick={expandText}
			class="text-body border-0 bg-transparent underline p-0 text-md cursor-pointer"
		>
			{m.poi_datasheet__see_more()}
		</button>
	{/if}
</DatasheetDetailBlock>
